import { getParticipantAuthToken } from '../../brix/connectors/auth/useParticipantAuthToken'

export const getParticipantBearerToken = () => {
  const token = getParticipantAuthToken()
  return `Bearer ${token}`
}
